export default __webpack_public_path__ + "static/media/finishing-4.548c1af5.webp";